import { useState } from "react";
import { createPortal } from "react-dom";

const TEXT = "minimum proof requirements demand at least one video file that proves honest completion of the given undertaking or xp entry. Additionally, users must include a handwritten physical sign indicating the current date and their username in the video.";

export function ProofButton({ testId = "proof-requirements-btn" }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} data-testid={testId} className="btn px-2 py-[1px] text-xs tracking-widest">proof</button>
      {open && createPortal(
        <div className="fixed inset-0 z-[60] flex items-center justify-center p-6 fade-in" style={{ background: "rgba(0,0,0,0.75)" }} onClick={() => setOpen(false)} data-testid="proof-requirements-overlay">
          <div className="w-full max-w-md p-8" style={{ background: "var(--bg-modal)", border: "1px solid var(--border)" }} onClick={(e) => e.stopPropagation()} data-testid="proof-requirements-modal">
            <div className="flex justify-between items-start mb-6">
              <span className="text-xs uppercase tracking-widest" style={{ color: "var(--text-muted)" }}>proof requirements</span>
              <button onClick={() => setOpen(false)} data-testid="proof-requirements-close" className="text-sm opacity-60 hover:opacity-100" style={{ color: "var(--text-primary)" }}>[ close ]</button>
            </div>
            <p className="text-sm leading-relaxed" style={{ color: "var(--text-primary)" }} data-testid="proof-requirements-text">{TEXT}</p>
          </div>
        </div>, document.body)}
    </>
  );
}
